import { IApplicationState } from '../../types/redux';

export const getPros = (state: IApplicationState): string => {
  return state.newReview.data.pros || '';
};
